<ion-content class="triangle-background">
  <div class="flex flex-col items-center mt-10 gap-40">
    <ion-icon class="w-64 h-64" name="gt-check-green"></ion-icon>
    <div class="flex flex-col items-center gap-4">
      @if (loading) {
        <ion-spinner name="dots" color="primary"></ion-spinner>
      } @else {
        <div class="text-center text-destacadoM">
          {{ 'CHECKOUT.PAYMENT_TRANSFER.TITLE' | transloco: { total: amountToPay ? amountToPay : '' } }}
        </div>
      }
      <div class="flex flex-col items-center">
        <ng-container *ngIf="bankAccount$ | async as bankAccount">
          <h3 class="text-center" [innerHTML]="bankAccount"></h3>
          <gt-button class="mt-4" (click)="copy(bankAccount)">
            <div class="flex gap-1 items-center justify-center">
              <ion-icon name="copy-outline"></ion-icon>
              <span> {{ 'CHECKOUT.PAYMENT_TRANSFER.COPY' | transloco }} </span>
            </div>
          </gt-button>
        </ng-container>
      </div>
      <gt-button *ngIf="showAcceptButton" routerLink="/home">{{ 'COMMON.ACCEPT' | transloco }}</gt-button>
    </div>
  </div>
</ion-content>
